import React from 'react';
import { MultiSelect } from 'react-multi-select-component';
import { Controller } from 'react-hook-form';

const MultiSelectComponent = ({
  options,
  className,
  name,
  label,
  inputRef,
  errors,
  control,
  watch,
  valor,
  aoMudar,
  defaultValue,
  ...rest
}) => {
  const msgErro = errors && errors[name]?.message;
  const traducao = {
    allItemsAreSelected: 'Todos os items estão selecionados.',
    clearSearch: 'Limpar Pesquisa',
    clearSelected: 'Limpar Selecionados',
    noOptions: 'Nenhum registro encontrado',
    search: 'Pesquisa',
    selectAll: 'Selecionar Todos',
    selectAllFiltered: 'Selecionar Todos (Filtrados)',
    selectSomeItems: 'Selecione um ou mais itens',
    create: 'Criar',
  };

  return (
    <div className={`campo ${className ? className : ''}`}>
      <div className="rotulo">
        <label className='subtitulo-p' htmlFor="numero">{label}</label>
      </div>
      <div className="controle">
        <Controller
          control={control}
          defaultValue={defaultValue || null}
          name={name}
          render={({ onChange, value, name, ref }) => (
            <MultiSelect
              options={[
                ...options.map((item) => ({
                  label: item.label,
                  value: item.value,
                })),
              ]}
              className={`multiselect-custom ${msgErro ? 'invalid' : ''}`}
              //className="col-12"
              name={name}
              ref={ref}
              {...rest}
              value={valor}
              onChange={(val) => {
                onChange(val || null);
                if (aoMudar) aoMudar(val || null);
              }}
              labelledBy="Selecione"
              overrideStrings={traducao}
              //{...formMethods}
            />
          )}
        />
      </div>
      <div className="mensagem">{msgErro}</div>
    </div>
  );
};

export default MultiSelectComponent;
